import Vue from "vue";

const state = {
  userAddresses: [],
  total: 0
};

const getters = {};

const actions = {
  LOAD_USER_ADDRESSES: async function({ commit }, payload) {
    Vue.prototype.$axios
      .get(
        "users/" +
          payload.userId +
          "/addresses?from=" +
          payload.from +
          "&limit=" +
          payload.to
      )
      .then(res => {
        commit("SET_USER_ADDRESSES", res.data.userAddresses);
        commit("SET_TOTAL", res.data.meta.total);
      });
  },
  CREATE_USER_ADDRESS: async function({ dispatch }, payload) {
    let label = `${payload.address.aptNo} ${payload.address.address}, ${payload.address.city}, ${payload.address.postcode}`;
    label = label.length > 25 ? `${label.substring(0, 25)}...` : label;
    await Vue.prototype.$axios
      .post("/users/" + payload.userId + "/addresses", {
        ...payload.address,
        label: label
      })
      .then(
        res => {},
        err => {
          throw new Error(err);
        }
      );
  },
  UPDATE_USER_ADDRESS: async function({ dispatch }, payload) {
    await Vue.prototype.$axios
      .post(
        "/users/" + payload.userId + "/addresses/" + payload.address.id,
        payload.address
      )
      .then(() => {});
  },
  DESTROY_USER_ADDRESS: async function({ commit }, payload) {
    await Vue.prototype.$axios
      .delete("users/" + payload.userId + "/addresses/" + payload.id)
      .then(
        res => {},
        err => {
          throw new Error(err);
        }
      );
  }
};

const mutations = {
  SET_USER_ADDRESSES: function(state, payload) {
    state.userAddresses = payload;
  },
  SET_TOTAL: function(state, payload) {
    state.total = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
